var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgPrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.998,
    height: 46.226,
    viewBox: "0 0 26.998 46.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccdb67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255300"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4538",
    "data-name": "Raggruppa 4538",
    transform: "translate(-2214.957 -433.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9560",
    "data-name": "Tracciato 9560",
    d: "M2228.664,433.172c.551,4.544-3.846,10.565-9.822,17.135-5.366,5.9-5.3,12.083.994,17.6-3.388-4.914-2.493-10.018,2.187-14.771,4.19-4.255,7.654-8.29,9.362-11.865-1.494,3.675-4.732,7.916-8.685,12.418-4.711,5.366-5.061,10.885-.492,15.862-.393-4.52,3.956-10.457,9.841-16.922C2238.024,446.062,2237.269,439.133,2228.664,433.172Z",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9561",
    "data-name": "Tracciato 9561",
    d: "M2299.482,568.575a5.069,5.069,0,0,1-.006.564,9.128,9.128,0,0,1-.268,5.2,10.71,10.71,0,0,1-1.34,1.909,3.236,3.236,0,0,0-.169.325,1.075,1.075,0,0,1,.2.322,4.613,4.613,0,0,0,1.57.252,3.1,3.1,0,0,1-1,.139,4.613,4.613,0,0,0,1.427.207,3.02,3.02,0,0,1-1.014.138l.11.044a4.647,4.647,0,0,0,1.588.255,3.466,3.466,0,0,1-2.155-.07,4.018,4.018,0,0,1-.48-.2,1.621,1.621,0,0,1-.043.16,1.436,1.436,0,0,1-.112.229,8.573,8.573,0,0,0,.6,1.22c1.139,1.994,1.184,2.088.771,2.564s-1.135.518-1.514.691-.764.427-.628.972c.084.337.5.614-.088,1.143-.317.287-.768.078-1.08.079s.362-.021.6.183a.719.719,0,0,1-.054,1,1.664,1.664,0,0,1-.7.287c-.164.019-.4.325-.412.475a7.175,7.175,0,0,1-.25,1.516c-.177.483-.454,1.754-1.852,1.391s-3.557-1.953-4.463-2.446c-.57-.308-1.638.212-2.291,1.351a3.975,3.975,0,0,0-.411,2.147c.1,2.99,1.9,6.043,5.565,9.008-.182-3.945,3.989-8.84,9.552-14.1S2306.5,574.257,2299.482,568.575Z",
    transform: "translate(-63.1 -120.234)",
    opacity: 0.8,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPrg);
export default __webpack_public_path__ + "static/media/SvgPrg.f50aab3286e5c1c631b11ef3184af338.svg";
export { ForwardRef as ReactComponent };